import TabPanel from "@/components/TabPanel/TabPanel";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import Banner, { BannerElement } from "@/components/Banner/Banner";
import { MotifIcon } from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import { useParams } from "react-router-dom";
import FormManagementSummary from "./FormManagement/FromManagementSummary";
import { useGetReadCustomFormApiQuery } from "./FormManagement/PortalConfigReducer";
import FormSetup from "./FormManagement/FormSetup/FormSetup";
import { useTranslation } from "react-i18next";
import PageTitle from "@/components/Form/PageTitle/PageTitle";
import { useSelector } from "react-redux";
import { ActiveTabsOrder } from "@/menuData";

export default function FormManagementTabs() {
  const { caseId, editId } = useParams();
  const {t}=useTranslation()
  const editView = editId ? true : false;
  const { data } = useGetReadCustomFormApiQuery(editId, {
    refetchOnMountOrArgChange: true,
    skip: !editId,
  });
  const { caseName } = useSelector((state: any) => state.case);

  const formData = data ? data : {};

  const tabPanelData = {
    title: ["pages.portalConfiguration.formTabPannel.tab1", "pages.portalConfiguration.formTabPannel.tab2"],
    content: [
      <FormManagementSummary formData={{ editView: editView }} />,
      <FormSetup />,
    ],
  };
  const tabPanelDatas = {
    title: ["pages.portalConfiguration.formTabPannel.tab1"],
    content: [
      <FormManagementSummary formData={{ editView: editView}} />,
    ],
  };

  const bannerElement: BannerElement[] = [
    {
      label: "pages.portalConfiguration.bannerDetails.lable1",
      value: formData?.status,
      elementKey: "caseID",
    },
  ];
  const breadcrumbItems = editView?[
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text:caseName,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.PORTAL}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text:formData?.name,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.PORTAL}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled:true
    },
  ]:[
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text:caseName,
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.PORTAL}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      label: "External Submission",
      value: "10 New Creditor Submission",
      elementKey: "submission",
      text:t("pages.portalConfiguration.createForm"),
      url: `/case/${caseId}/?activeTab=${ActiveTabsOrder.PORTAL}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled:true
    },
  ];

  if (!editView) {
    return (
      <>
        <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
        <PageTitle
          title={t("pages.portalConfiguration.createFormTitle")}
        />
        <div className="ccwp_table_wrapper ccwp_table_dropdown_wrapper">
          <TabPanel key="create" data={tabPanelDatas} />
        </div>
      </>
    );
  }

  return (
    <>
      <Breadcrumb items={breadcrumbItems} ariaLabel="Breadcrumb navigation" />
      <Banner
        bannerName={"pages.portalConfiguration.bannerDetails.title"}
        bannerNameValue={formData?.name}
        elements={bannerElement}
      />
      <div className="ccwp_table_wrapper ccwp_table_dropdown_wrapper">
        <TabPanel key="edit" data={tabPanelData} />
      </div>
    </>
  );
}
